export default class Counter {
	constructor({ elements }) {
		elements.forEach((el) => {
			const { value } = el.dataset;
			// eslint-disable-next-line no-undef
			const odometer = new Odometer({
				el,
				format: 'd ddd ddd',
			});
			const options = {
				rootMargin: '0px',
				threshold: 1.0,
			};
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0) {
						odometer.update(value);
					}
				});
			}, options);
			observer.observe(el);
		});
	}
}
